import React from 'react';
import { Button } from 'shards-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from '../../../redux/store';
import { setDialogMode, openDialog, selectNews } from '../../../redux/slices/news';

const AddNews = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * モーダルオープン
   */
  const handleAddNews = (): void => {
    dispatch(selectNews());
    dispatch(setDialogMode('CREATE'));
    dispatch(openDialog());
  };

  // VIEW
  // ================================================================================

  return (
    <Button className="mr-2" theme="white" onClick={handleAddNews}>
      <i className="material-icons">add</i> {t('information.news.add')}
    </Button>
  );
};

export default AddNews;
